var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradYears(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.166,
    height: 40.166,
    viewBox: "0 0 40.166 40.166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grad_Years",
    "data-name": "Grad Years",
    transform: "translate(10137 13931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M2.51,9.781v25.1a2.51,2.51,0,0,0,2.51,2.51H35.145a2.51,2.51,0,0,0,2.51-2.51V9.781ZM5.021,2.25A5.021,5.021,0,0,0,0,7.271V34.885a5.021,5.021,0,0,0,5.021,5.021H35.145a5.021,5.021,0,0,0,5.021-5.021V7.271A5.021,5.021,0,0,0,35.145,2.25Z",
    transform: "translate(-10137 -13930.739)",
    fill: "#3e3e3e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M8.005,0A1.255,1.255,0,0,1,9.26,1.255V2.51a1.255,1.255,0,0,1-2.51,0V1.255A1.255,1.255,0,0,1,8.005,0ZM30.6,0a1.255,1.255,0,0,1,1.255,1.255V2.51a1.255,1.255,0,0,1-2.51,0V1.255A1.255,1.255,0,0,1,30.6,0Z",
    transform: "translate(-10136.219 -13931)",
    fill: "#3e3e3e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "graduation-cap",
    d: "M21.992,8.777l.223,3.918A1.863,1.863,0,0,1,21.2,14.282a8.6,8.6,0,0,1-2.913,1.159,17.736,17.736,0,0,1-4,.428,17.736,17.736,0,0,1-4-.428,8.6,8.6,0,0,1-2.913-1.159,1.863,1.863,0,0,1-1.016-1.587L6.57,8.777l7.116,2.244a2.09,2.09,0,0,0,1.19,0Zm6.57-4.017a.377.377,0,0,1-.273.384L14.4,9.508a.61.61,0,0,1-.248,0L6.074,6.955a3.024,3.024,0,0,0-.88,1.382,7.9,7.9,0,0,0-.421,2.213A1.458,1.458,0,0,1,5.554,11.9a1.5,1.5,0,0,1-.719,1.327L5.554,18.6a.4.4,0,0,1-.4.447H2.777a.4.4,0,0,1-.4-.447L3.1,13.227a1.58,1.58,0,0,1,.087-2.7A7.689,7.689,0,0,1,4.4,6.434L.273,5.144a.407.407,0,0,1,0-.768L14.157.013a.61.61,0,0,1,.248,0L28.289,4.376a.377.377,0,0,1,.273.384Z",
    transform: "translate(-10131.373 -13915.975)",
    fill: "#3e3e3e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradYears);
export default __webpack_public_path__ + "static/media/GradYears.872609f2fee3e1d07274919f83811a01.svg";
export { ForwardRef as ReactComponent };